import { AddCalendarEvent, AttendanceStatus, CalendarEventModel, CalendarEventResponse, UpdateCalendarEvent } from "../../../entities";
import BaseDataRepository from "../../BaseDataRepository";
export class CalendarEventRepo extends BaseDataRepository<CalendarEventModel> {
  protected baseUrl = "calendarevent";

  async getByUserLocationAsync(userId?: number | string, locationId?: number | string, startDate?: string, endDate?: string): Promise<CalendarEventModel[]> {
    let url = `${this.baseUrl}/getusercalendarevents?userId=${userId}&locationId=${locationId}`;
    if (startDate && endDate) {
      url += `&startDate=${startDate}&endDate=${endDate}`;
    }
    const response = await this.client.get(url);
    return this.handleResponse<CalendarEventModel[]>(response)!
  }

  async getByLocationProviderAsync(locationId: number | string, providerId: number | string, startDate?: string, endDate?: string): Promise<CalendarEventModel[]> {
    let url = `${this.baseUrl}/geteventsbylocationprovider?locationId=${locationId}&providerId=${providerId}`;
    if (startDate && endDate) {
      url += `&startDate=${startDate}&endDate=${endDate}`;
    }
    const response = await this.client.get(url);
    return this.handleResponse<CalendarEventModel[]>(response)!
  }

  async exportCalendarAsync(userId: number): Promise<string> {
    const response = await this.client.get(`${this.baseUrl}/exportcalendar?userId=${userId}`);
    return this.handleResponse<string>(response)!
  }

  async getByLocationCodeProviderAsync(locationCode: string, providerId: number | string): Promise<CalendarEventModel[]> {
    const response = await this.client.get(`${this.baseUrl}/getbylocationcodeprovider?locationCode=${locationCode}&providerId=${providerId}`);
    return this.handleResponse<CalendarEventModel[]>(response)!;
  }

  async getLatestCustomerNotesAsync(customerId: number): Promise<CalendarEventModel | null> {
    const response = await this.client.get(`${this.baseUrl}/getlatestcustomernotes?customerId=${customerId}`);
    const result = this.handleResponse<CalendarEventModel>(response, false, false);
    return result && typeof result === "object" ? result : null;
  }

  async updateCalendarEventAsync(calendarEvent: UpdateCalendarEvent): Promise<CalendarEventResponse> {
    const response = await this.client.patch(`${this.baseUrl}/updateCalendarEvent`, calendarEvent);
    return this.handleResponse<CalendarEventResponse>(response)!;
  }

  async addCalendarEventAsync(eventInformation: AddCalendarEvent): Promise<CalendarEventResponse> {
    const response = await this.client.post(`${this.baseUrl}/addCalendarEvent`, eventInformation);
    return this.handleResponse<CalendarEventResponse>(response)!;
  }

  async updateAttendanceStatusAsync(bookingEventId: number, attendanceStatus: AttendanceStatus): Promise<boolean> {
    const response = await this.client.patch(`${this.baseUrl}/updateAttendanceStatus`, { bookingEventId, attendanceStatus });
    return this.handleResponse<boolean>(response)!;
  }

  async deleteCalendarEventAsync(bookingEventId: number): Promise<boolean> {
    const response = await this.client.delete(`${this.baseUrl}/deleteCalendarEvent?bookingEventId=${bookingEventId}`);
    return this.handleResponse(response);

  }
}

export default CalendarEventRepo;
